import { render, staticRenderFns } from "./CustomerPermissionModal.vue?vue&type=template&id=006facfb&scoped=true"
import script from "./CustomerPermissionModal.vue?vue&type=script&lang=js"
export * from "./CustomerPermissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006facfb",
  null
  
)

export default component.exports